<button type="button" class="ask-fab" *ngIf="visible" (click)="open()"
  title="Ask the data" aria-label="Ask the data">
  <ps-outline-icon name="lightbulb"></ps-outline-icon>
</button>
